import React, { createContext, useContext, useState, ReactNode } from 'react';

export type MapProviderType = 'google' | 'yandex';

interface MapProviderContextType {
  mapProvider: MapProviderType;
  setMapProvider: (provider: MapProviderType) => void;
}

const MapProviderContext = createContext<MapProviderContextType | undefined>(undefined);

interface MapProviderProps {
  children: ReactNode;
  defaultProvider?: MapProviderType;
}

export const MapProvider: React.FC<MapProviderProps> = ({ children, defaultProvider = 'google' }) => {
  const [mapProvider, setMapProvider] = useState<MapProviderType>(defaultProvider);

  return <MapProviderContext.Provider value={{ mapProvider, setMapProvider }}>{children}</MapProviderContext.Provider>;
};

export const useMapProvider = (): MapProviderContextType => {
  const context = useContext(MapProviderContext);
  if (context === undefined) {
    throw new Error('useMapProvider must be used within a MapProvider');
  }
  return context;
};
